import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useBlocker } from "@tanstack/react-router";

interface LeaveConfirmCopy {
  title?: string;
  content?: string;
  cancelText?: string;
  proceedText?: string;
}

interface NavigationBlockerModalProps extends LeaveConfirmCopy {
  shouldBlock: boolean;
  enableBeforeUnload: boolean;
}

interface LeaveConfirmDialogProps extends LeaveConfirmCopy {
  open: boolean;
  onCancel: () => void;
  onProceed: () => void;
}

/**
 * The "leave without saving?" prompt on its own, for in-page moves that act
 * like navigation (e.g. switching tabs that swap out the editor).
 */
export function LeaveConfirmDialog({
  open,
  onCancel,
  onProceed,
  title = "Confirm Navigation",
  content = "Are you sure you want to leave this page?",
  cancelText = "Cancel",
  proceedText = "Leave Page",
}: LeaveConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{cancelText}</Button>
        <Button onClick={onProceed} variant="contained">
          {proceedText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function NavigationBlockerModal({
  shouldBlock,
  enableBeforeUnload,
  ...copy
}: NavigationBlockerModalProps) {
  const { proceed, reset, status } = useBlocker({
    shouldBlockFn: () => shouldBlock,
    withResolver: true,
    enableBeforeUnload: enableBeforeUnload && shouldBlock,
  });

  return (
    <>
      {status === "blocked" && (
        <LeaveConfirmDialog
          open
          onCancel={() => reset?.()}
          onProceed={() => proceed?.()}
          {...copy}
        />
      )}
    </>
  );
}
